var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrpMenuItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 0C3 0.857507 3.00002 6.8378 3 8.07261C2.99998 9.05875 5.1214 11.322 6.92982 12.7032C8.89474 14.2038 10.5322 13.9894 12.4215 13.9894C13.933 13.9894 18.6221 13.9894 19 13.9894",
  stroke: "currentColor",
  strokeOpacity: 1,
  strokeWidth: 2,
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3333 13L13 11.8571L12 11L12.3333 9",
  stroke: "currentColor",
  strokeOpacity: 0.56,
  strokeWidth: 0.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6667 9L17 10.1429L18 11L17.6667 13",
  stroke: "currentColor",
  strokeOpacity: 0.56,
  strokeWidth: 0.5
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3333 19L11 17.8571L10 17L10.3333 15",
  stroke: "currentColor",
  strokeOpacity: 0.56,
  strokeWidth: 0.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6667 15L15 16.1429L16 17L15.6667 19",
  stroke: "currentColor",
  strokeOpacity: 0.56,
  strokeWidth: 0.5
})));
export { SvgGrpMenuItem as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMyAwQzMgMC44NTc1MDcgMy4wMDAwMiA2LjgzNzggMyA4LjA3MjYxQzIuOTk5OTggOS4wNTg3NSA1LjEyMTQgMTEuMzIyIDYuOTI5ODIgMTIuNzAzMkM4Ljg5NDc0IDE0LjIwMzggMTAuNTMyMiAxMy45ODk0IDEyLjQyMTUgMTMuOTg5NEMxMy45MzMgMTMuOTg5NCAxOC42MjIxIDEzLjk4OTQgMTkgMTMuOTg5NCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIxIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiLz4KICA8cGF0aCBkPSJNMTIuMzMzMyAxM0wxMyAxMS44NTcxTDEyIDExTDEyLjMzMzMgOSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjU2IiBzdHJva2Utd2lkdGg9IjAuNSIvPgogIDxwYXRoIGQ9Ik0xNy42NjY3IDlMMTcgMTAuMTQyOUwxOCAxMUwxNy42NjY3IDEzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjAuNTYiIHN0cm9rZS13aWR0aD0iMC41Ii8+CiAgPHBhdGggZD0iTTEwLjMzMzMgMTlMMTEgMTcuODU3MUwxMCAxN0wxMC4zMzMzIDE1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjAuNTYiIHN0cm9rZS13aWR0aD0iMC41Ii8+CiAgPHBhdGggZD0iTTE1LjY2NjcgMTVMMTUgMTYuMTQyOUwxNiAxN0wxNS42NjY3IDE5IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjAuNTYiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPg==";